import { useCallback, useEffect, useRef, useState } from 'react'

const now = () => Date.now()

/**
 * Setler arası dinlenme sayacı.
 *
 * Mola sayacıyla aynı disiplin: kalan süre saniye sayarak DEĞİL, bitiş zaman
 * damgasından hesaplanıyor. Arka plan sekmesinde setInterval dakikada bire kadar
 * kısılıyor — sayaç azaltsaydı 90 saniyelik dinlenme 3 dakika sürerdi. Telefonu
 * cebe koyup bekleyen biri için bu doğrudan bozuk bir üründür.
 *
 * State provider'da yaşıyor; sekme değiştirince sayaç durmasın diye.
 */
export function useRestTimer(soundOn: boolean) {
  const [endsAt, setEndsAt] = useState<number | null>(null)
  const [total, setTotal] = useState(0)
  const [label, setLabel] = useState('')
  const [, setTick] = useState(0)

  const sound = useRef(soundOn); sound.current = soundOn
  const blinkId = useRef<number | null>(null)

  const running = endsAt !== null
  const left = running ? Math.max(0, Math.ceil((endsAt - now()) / 1000)) : 0

  /** Bitiş sinyali. Telefon yerde olabilir — sesli uyarı burada süs değil, işlev. */
  const cue = useCallback(() => {
    try { navigator.vibrate?.([120, 80, 120]) } catch { /* desteklenmiyorsa yok say */ }
    if (!sound.current) return
    try {
      const Ctx = window.AudioContext ||
        (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
      const ctx = new Ctx()
      // Mola sayacından farklı bir tını: ikisi aynı anda çalabilir,
      // hangisinin bittiğini duyabilmek lazım.
      ;[988, 1319].forEach((f, i) => {
        const osc = ctx.createOscillator(); const gain = ctx.createGain()
        osc.type = 'triangle'; osc.frequency.value = f
        const t = ctx.currentTime + i * 0.16
        gain.gain.setValueAtTime(0.0001, t)
        gain.gain.exponentialRampToValueAtTime(0.3, t + 0.02)
        gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.15)
        osc.connect(gain); gain.connect(ctx.destination)
        osc.start(t); osc.stop(t + 0.17)
      })
      setTimeout(() => void ctx.close(), 900)
    } catch { /* ses yoksa sessizce devam */ }
  }, [])

  const blink = useCallback(() => {
    if (document.visibilityState === 'visible') return
    if (blinkId.current) window.clearInterval(blinkId.current)
    const base = 'Kilo Takip Paneli'
    let on = false, n = 0
    blinkId.current = window.setInterval(() => {
      document.title = (on = !on) ? '💪 Sıradaki set' : base
      if (++n > 20) { if (blinkId.current) window.clearInterval(blinkId.current); document.title = base }
    }, 700)
    window.addEventListener('focus', () => {
      if (blinkId.current) window.clearInterval(blinkId.current)
      document.title = base
    }, { once: true })
  }, [])

  const start = useCallback((seconds: number, text = '') => {
    if (seconds <= 0) return
    setTotal(seconds)
    setLabel(text)
    setEndsAt(now() + seconds * 1000)
  }, [])

  const stop = useCallback(() => { setEndsAt(null); setTotal(0); setLabel('') }, [])

  /** Süre eklemek dinlenmeyi uzatır; toplam da büyür ki çubuk geri zıplamasın. */
  const add = useCallback((seconds: number) => {
    setEndsAt((e) => (e === null ? e : e + seconds * 1000))
    setTotal((t) => t + seconds)
  }, [])

  useEffect(() => {
    if (endsAt === null) return
    const id = window.setInterval(() => {
      if (now() >= endsAt) {
        cue(); blink()
        setEndsAt(null)
      }
      setTick((n) => n + 1)
    }, 250)
    return () => window.clearInterval(id)
  }, [endsAt, cue, blink])

  return {
    left, total, label, running,
    progress: total > 0 ? 1 - left / total : 0,
    start, stop, add,
  }
}

/** "1:30" / "45 sn" */
export function formatRest(seconds: number): string {
  if (seconds < 60) return `${seconds} sn`
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m}:${String(s).padStart(2, '0')}`
}
